import { EmailStatus } from 'types';
export const EmaliStatusLabelToCode = {
  Bounced: 'bounce',
  Deferred: 'deferred',
  Delivered: 'delivered',
  Dropped: 'dropped',
  Opened: 'open',
  Processed: 'processed',
  Spamreport: 'spamreport',
  Unsubscribed: 'unsubscribe',
  Clicked: 'click'
};

export const EmaliStatusCodeToLabel = {
  bounce: 'Bounced',
  deferred: 'Deferred',
  delivered: 'Delivered',
  dropped: 'Dropped',
  open: 'Opened',
  processed: 'Processed',
  spamreport: 'Spamreport',
  unsubscribed: 'Unsubscribe',
  click: 'Clicked'
};

export const convertEmaliStatusTolabel = (status: EmailStatus) => {
  return EmaliStatusCodeToLabel[status] || '';
};
